// extracted by mini-css-extract-plugin
export default {"mainContainer":"Download_mainContainer__wpAzi","title":"Download_title__phvR8","linkContainer":"Download_linkContainer__mUN2A","link":"Download_link__sul2L"};